import { useState } from "react";

interface VideoBoxProps {
  poster: string;
  title: string;
}

export default function VideoBox({ poster, title }: VideoBoxProps) {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-foreground-950">
      <img
        src={poster}
        alt={`${title}预告片封面`}
        title={`${title} - 视频预告 - 星光传媒`}
        className="h-full w-full object-cover object-top opacity-80"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />

      {!playing ? (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          className="group absolute inset-0 flex flex-col items-center justify-center"
          aria-label="播放预告片"
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-background-50 transition-transform group-hover:scale-110 md:h-20 md:w-20">
            <i className="ri-play-fill text-3xl md:text-4xl" />
          </span>
          <span className="mt-4 text-sm font-medium text-background-100">
            {title} · 官方预告片
          </span>
        </button>
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-accent-400 border-t-transparent animate-spin" />
          <p className="text-sm text-background-100">演示播放器正在缓冲…</p>
          <p className="max-w-xs text-xs text-background-400">
            当前为界面预留与模拟展示，暂未接入真实视频播放服务。
          </p>
          <button
            type="button"
            onClick={() => setPlaying(false)}
            className="mt-1 rounded-md border border-background-50/30 px-4 py-1.5 text-xs text-background-100 transition-colors hover:bg-background-50/10"
          >
            返回封面
          </button>
        </div>
      )}
    </div>
  );
}